// ===========================================================
// ERP BARCODE SCANNER MODULE (Quagga2)
// ===========================================================

let scannerActive = false;
let scanTimeout = null;
let currentCamera = "environment";

// Main scanner start function
window.startScanner = function(mode = 'inventory') {
  console.log("Starting scanner in mode:", mode);
  
  if (typeof Quagga === 'undefined') {
    alert("Scanner library loading... Please try again in 2 seconds.");
    setTimeout(() => startScanner(mode), 2000);
    return;
  }

  const modal = document.getElementById('scanner-modal');
  if (!modal) {
    createScannerModal();
    return startScanner(mode);
  }
  
  modal.style.display = 'flex';
  scannerActive = true;

  Quagga.init({
    inputStream: {
      name: "Live",
      type: "LiveStream",
      target: document.querySelector('#interactive'),
      constraints: {
        facingMode: currentCamera,
        width: { min: 640, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 720, max: 1080 },
        aspectRatio: { min: 1, max: 2 }
      },
      area: {
        top: "25%",
        right: "10%",
        left: "10%",
        bottom: "25%"
      }
    },
    locator: {
      patchSize: "medium",
      halfSample: true
    },
    numOfWorkers: navigator.hardwareConcurrency || 4,
    frequency: 10,
    decoder: {
      readers: [
        "code_128_reader",
        "ean_reader",
        "ean_8_reader",
        "upc_reader",
        "upc_e_reader",
        "code_39_reader",
        "code_39_vin_reader",
        "codabar_reader",
        "i2of5_reader",
        "2of5_reader",
        "code_93_reader"
      ]
    },
    locate: true
  }, function(err) {
    if (err) {
      console.error("Quagga Init Error:", err);
      alert("Camera error: " + err.message);
      window.stopScanner();
      return;
    }
    
    console.log("Quagga initialized successfully");
    Quagga.start();
    addScannerOverlay();
  });

  Quagga.onDetected(function(result) {
    const code = result.codeResult.code;
    if (!code || code.length < 3) return;
    
    if (scanTimeout) clearTimeout(scanTimeout);
    scanTimeout = setTimeout(() => {
      handleScannedCode(code, mode);
    }, 300);
  });
};

// Handle scanned code
function handleScannedCode(code, mode) {
  console.log("Handling scanned code:", code, "Mode:", mode);
  
  if (navigator.vibrate) navigator.vibrate(200);
  window.stopScanner();
  
  if (mode === 'attendance') {
    const input = document.getElementById('attendance-employee-id');
    if (input) {
      input.value = code;
      if (typeof window.handleAttendanceSubmit === 'function') {
        window.handleAttendanceSubmit(code);
      }
    }
  } else {
    const searchInput = document.getElementById('inv-search');
    if (searchInput) {
      searchInput.value = code;
      searchInput.style.background = "#dcfce7";
      setTimeout(() => searchInput.style.background = "", 500);
      if (typeof window.filterInventory === 'function') {
        window.filterInventory();
      }
      showScanSuccess(code);
    }
  }
}

// Show scan success
function showScanSuccess(code) {
  let notif = document.getElementById('scan-notification');
  if (!notif) {
    notif = document.createElement('div');
    notif.id = 'scan-notification';
    notif.style.cssText = `
      position: fixed;
      top: 80px;
      right: 20px;
      background: #10b981;
      color: white;
      padding: 15px 25px;
      border-radius: 8px;
      font-weight: 600;
      z-index: 10000;
      transform: translateX(400px);
      transition: transform 0.3s ease;
    `;
    document.body.appendChild(notif);
  }
  
  notif.innerHTML = `✅ Barcode Found: <b>${code}</b>`;
  notif.style.transform = "translateX(0)";
  
  setTimeout(() => {
    notif.style.transform = "translateX(400px)";
  }, 3000);
}

// Add scanner overlay
function addScannerOverlay() {
  const viewport = document.querySelector('#interactive');
  if (!viewport) return;
  
  const oldOverlay = viewport.querySelector('.scanner-overlay');
  if (oldOverlay) oldOverlay.remove();
  
  const overlay = document.createElement('div');
  overlay.className = 'scanner-overlay';
  overlay.style.cssText = `
    position: absolute;
    top: 25%;
    left: 10%;
    right: 10%;
    bottom: 25%;
    border: 2px solid #10b981;
    border-radius: 12px;
    box-shadow: 0 0 0 9999px rgba(0,0,0,0.5);
    pointer-events: none;
    z-index: 10;
  `;
  
  const corners = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
  corners.forEach(corner => {
    const marker = document.createElement('div');
    marker.style.cssText = `
      position: absolute;
      width: 20px;
      height: 20px;
      border-color: #10b981;
      border-style: solid;
      ${corner.includes('top') ? 'top: -2px; border-top-width: 4px;' : 'bottom: -2px; border-bottom-width: 4px;'}
      ${corner.includes('left') ? 'left: -2px; border-left-width: 4px;' : 'right: -2px; border-right-width: 4px;'}
    `;
    overlay.appendChild(marker);
  });
  
  const text = document.createElement('div');
  text.innerText = "Align barcode within frame";
  text.style.cssText = `
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-size: 14px;
    white-space: nowrap;
  `;
  overlay.appendChild(text);
  
  viewport.appendChild(overlay);
}

// Stop scanner
window.stopScanner = function() {
  console.log("Stopping scanner...");
  scannerActive = false;
  
  if (typeof Quagga !== 'undefined') {
    Quagga.stop();
    Quagga.offDetected();
    Quagga.offProcessed();
  }
  
  const modal = document.getElementById('scanner-modal');
  if (modal) modal.style.display = 'none';
  
  const overlay = document.querySelector('.scanner-overlay');
  if (overlay) overlay.remove();
  
  if (scanTimeout) {
    clearTimeout(scanTimeout);
    scanTimeout = null;
  }
};

// Create scanner modal
function createScannerModal() {
  const modal = document.createElement('div');
  modal.id = 'scanner-modal';
  modal.className = 'modal-overlay';
  modal.style.cssText = `
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.9);
    z-index: 9999;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `;
  
  modal.innerHTML = `
    <div class="scanner-card" style="
      background: #1f2937;
      padding: 20px;
      border-radius: 16px;
      width: 90%;
      max-width: 500px;
    ">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
        <h3 style="margin: 0; color: white;">📷 Scan Barcode</h3>
        <button onclick="window.stopScanner()" style="
          background: #ef4444;
          color: white;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 18px;
        ">×</button>
      </div>
      <div id="interactive" style="
        height: 300px;
        background: black;
        border-radius: 12px;
        overflow: hidden;
        position: relative;
      "></div>
      <div style="margin-top: 15px; display: flex; gap: 10px; justify-content: center;">
        <button onclick="window.toggleFlashlight()" style="
          background: #3b82f6;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
        ">🔦 Flashlight</button>
        <button onclick="window.switchCamera()" style="
          background: #6b7280;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
        ">🔄 Switch Camera</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(modal);
}

// Toggle flashlight
window.toggleFlashlight = async function() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: currentCamera }
    });
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();
    
    if (capabilities.torch) {
      const settings = track.getSettings();
      await track.applyConstraints({
        advanced: [{ torch: !settings.torch }]
      });
    } else {
      alert("Flashlight not supported on this device");
    }
  } catch (err) {
    console.error("Flashlight error:", err);
    alert("Cannot access flashlight");
  }
};

// Switch camera
window.switchCamera = function() {
  window.stopScanner();
  currentCamera = currentCamera === "environment" ? "user" : "environment";
  setTimeout(() => window.startScanner(), 500);
};